import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}



export default props => {
    const {
        offices,
        selectOffice,
        showZone = true
    } = props

    const handleSelectOffice = office => {
        selectOffice(office)
    }

    const isMobile = true


    return (
        <div className='list-offices'>
            {offices && offices.map((office, i) =>
                <div className='office-item' onClick={() => handleSelectOffice(office)} key={i}>
                    <div className='office-icon'>
                        {office.type === 'Aeropuerto' && <FontAwesomeIcon icon="plane-departure" />}
                        {office.type === 'Hotel' && <FontAwesomeIcon icon="hotel" />}
                        {office.type === 'Muelle' && <FontAwesomeIcon icon="anchor" />}
                        {office.type === 'Oficina' && <FontAwesomeIcon icon="building" />}
                    </div>

                    {isMobile ? (
                        <div className='office-name-block'>
                            <div className='office-name'>{office.name}</div>
                            {showZone && <div className='office-city'>{office.city}</div>}
                        </div>
                    ) : (
                        <>
                            <div className='office-name'>{office.name}</div>
                            {showZone && <div className='office-zone'>{office.city}</div>}
                        </>
                    )}
                </div>
            )}
        </div>
    )
}

